const IconBlack = ({ size, color }) => {
  return (
    <svg
      width={size ? size : "11"}
      height="20"
      viewBox="0 0 11 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 1L1 10L10 19"
        stroke={color ? color : "white"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconBlack;
